import { TripGroupingInput } from '../../lib/types/models/trip-grouping/trip-grouping-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripGrouping({ id, ...data }: UpdateInput<TripGroupingInput>) {
  return restApiClient.url(constructApiUrl(API.tripGroupings.update.url, { id })).patch(data)
}
